import type { SectorPathData } from './svgParser';

export const buildSectorCenters = (sectorPaths: SectorPathData[]) => {
  if (sectorPaths.length === 0) return new Map<string, { x: number; y: number }>();

  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  document.body.appendChild(svg);
  const centers = new Map<string, { x: number; y: number }>();

  sectorPaths.forEach(sector => {
    const pathEl = document.createElementNS(svgNS, 'path');
    pathEl.setAttribute('d', sector.path);
    svg.appendChild(pathEl);
    try {
      const bbox = pathEl.getBBox();
      centers.set(sector.name, { x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2 });
    } catch {
      // Ignore malformed preview geometry.
    } finally {
      svg.removeChild(pathEl);
    }
  });

  document.body.removeChild(svg);
  return centers;
};
